




































































































































import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Prop } from 'vue-property-decorator';

import 'vue-select/dist/vue-select.css';
import VueApexCharts from 'vue-apexcharts';
import {
  AdmiralException,
  GoalValueType,
  IFivGoal,
  IFivGoalResult,
  IFivReport,
} from 'admiral-core';
import {
  ChevronDownIcon,
  ChevronUpIcon,
  InfoIcon,
  MoreVerticalIcon,
  MoveIcon,
  SettingsIcon,
} from 'vue-feather-icons';
import { mixins } from 'vue-class-component';
import { BaseMixin } from '@/mixins/BaseMixin';
import { GoalApi } from '@/services/GoalApi';
import ContextMenu from '@/components/common/ContextMenu.vue';
import Avatar from '@/components/common/Avatar.vue';
import PolicyStatusBadge from '@/components/common/PolicyStatusBadge.vue';
import GoalAchievementChart from '@/views/pages/fivgoals/GoalAchievementChart.vue';
import FivGoalForm from '@/forms/FivGoalForm.vue';
import EditFivGoalModal from '@/views/pages/fivgoals/EditFivGoalModal.vue';

@Component({
  components: {
    EditFivGoalModal,
    FivGoalForm,
    Avatar,
    ContextMenu,
    SettingsIcon,
    MoveIcon,
    MoreVerticalIcon,
    GoalAchievementChart,
    apexchart: VueApexCharts,
    PolicyStatusBadge,
    ChevronDownIcon,
    ChevronUpIcon,
    InfoIcon,
  },
})
export default class FivRangeGoalChart extends mixins(BaseMixin) {
  @Prop({ type: String })
  name!: string;

  @Prop({ type: Array })
  goals!: IFivGoal[];

  @Prop({ required: true, type: Object })
  report!: IFivReport;

  @Prop({ required: false, type: Boolean, default: () => true })
  hasHandle!: boolean;

  contextMenuVisible = false;
  showLeads = false;

  error: string | null = null;

  goalResult1: Partial<IFivGoalResult> = {
    name: '',
    timeValue: 0,
    timeQuantity: 0,

    leadsValue: 0,
    leadsQuantity: 0,
    lastYearValue: 0,
    lastYearQuantity: 0,
    value: 0,
    quantity: 0,
    endValue: 0,
    // @ts-ignore
    goal: {
      name: '',
    },
  };
  goalResult2: Partial<IFivGoalResult> = {
    name: '',
    timeValue: 0,
    timeQuantity: 0,

    leadsValue: 0,
    leadsQuantity: 0,
    lastYearValue: 0,
    lastYearQuantity: 0,
    value: 0,
    quantity: 0,
    endValue: 0,
    // @ts-ignore
    goal: {
      name: '',
    },
  };

  max = 0;

  series: ApexAxisChartSeries = [];

  loading = false;

  get goalValueTypeValuation1() {
    return this.goalResult1?.goal?.valueType === GoalValueType.Valuation;
  }
  get goalValueTypeQuantity1() {
    return this.goalResult1?.goal?.valueType === GoalValueType.Quantity;
  }

  get goalValueTypeValuation2() {
    return this.goalResult2?.goal?.valueType === GoalValueType.Valuation;
  }
  get goalValueTypeQuantity2() {
    return this.goalResult2?.goal?.valueType === GoalValueType.Quantity;
  }

  get result() {
    return this.goalValueTypeValuation1 ? this.goalResult1.value : this.goalResult1.quantity;
  }

  get goalProducts() {
    return this.goalResult1 ? this.goalResult1?.goal?.products : [];
  }

  get valueType() {
    return this.goalValueTypeValuation1 ? 'Nach Bewertung' : 'Nach Stückzahl';
  }

  get submitted() {
    return this.goalValueTypeValuation1
      ? this.goalResult1!.submittedValue || 0
      : this.goalResult1!.submittedQuantity || 0;
  }

  get open() {
    return this.goalValueTypeValuation1
      ? this.goalResult1!.openValue || 0
      : this.goalResult1!.openQuantity || 0;
  }

  get leads() {
    return this.submitted + this.open;
  }

  get end1() {
    return this.goalValueTypeValuation1
      ? this.goalResult1!.endValue
      : this.goalResult1!.endQuantity;
  }
  get end2() {
    return this.goalValueTypeValuation1
      ? this.goalResult2!.endValue
      : this.goalResult2!.endQuantity;
  }

  get time() {
    return this.goalValueTypeValuation1
      ? this.goalResult1!.timeValue
      : this.goalResult1!.timeQuantity;
  }

  get lastYear() {
    return this.goalValueTypeValuation1
      ? this.goalResult1!.lastYearValue
      : this.goalResult1!.lastYearQuantity;
  }

  async loadResult() {
    try {
      this.loading = true;

      const result1 = await GoalApi.getFivGoalResult({
        name: this.goals[0].name,
        goalGroup: this.report.goalGroup,
        report: this.report,
      });
      this.goalResult1 = result1.data;

      if (this.goals.length > 1) {
        const result2 = await GoalApi.getFivGoalResult({
          name: this.goals[1].name,
          goalGroup: this.report.goalGroup,
          report: this.report,
        });
        this.goalResult2 = result2.data;
      }
    } catch (e: any) {
      const exception = e.response?.data as AdmiralException;
      if (exception.errors) { // eslint-disable-line
        const errors = exception.errors;
        if (errors['MissingGoal']) {
          this.error = 'Ziel nicht gefunden.';
        }
      }
    }
    this.loading = false;

    this.chartOptions.xaxis.categories = ['', 'VJ', 'Erg. + Anb.', ''];
    this.chartOptions.colors = [
      this.colors.lastYear,
      this.colors.result,
      this.colors.submitted,
      this.colors.open,
      this.colors.time,
    ];
    this.series = [
      {
        // @ts-ignore
        name: `Ergebnis VJ: ${this.lastYear.toLocaleString('de-DE')}`,
        // @ts-ignore
        data: [0, (this.lastYear as number) > 0 ? (this.lastYear as number) : 0, 0],
      },
      {
        // @ts-ignore
        name: `Ergebnis: ${this.result.toLocaleString('de-DE')}`,
        // @ts-ignore
        data: [0, 0, this.result as number, 0],
      },
      {
        // @ts-ignore
        name: `Eingereicht: ${this.submitted.toLocaleString('de-DE')}`,

        // @ts-ignore
        data: [0, 0, this.submitted, 0],
      },
      {
        // @ts-ignore
        name: `Offen: ${this.open.toLocaleString('de-DE')}`,

        // @ts-ignore
        data: [0, 0, this.open, 0],
      },
    ];

    const values = [
      this.end1 || 0,
      this.end2 || 0,

      this.open || 0,
      this.submitted || 0,
      this.result || 0,
      this.time || 0,

      (this.result || 0) + (this.leads || 0),
      this.goalResult1?.goal?.agencyValue || 0,
    ];
    values.push();

    this.max = Math.max(...values);
    const annotations: any = [];

    annotations.push({
      y: this.end1,
      strokeDashArray: 3,
      borderColor: '#32557c',
      fillColor: '#32557c',
      opacity: 1,
      stroke: {
        width: [4],
      },
      label: {
        borderColor: '#32557c',
        offsetX: -6,
        offsetY: 6,
        style: {
          color: '#fff',
          background: '#32557c',
        },
        // @ts-ignore
        text:
          this.getShortName(this.goalResult1?.goal?.name) +
          ' ' +
          this.end1!.toLocaleString('de-DE'),
      },
    });

    if (this.goalResult2.name !== '') {
      annotations.push({
        y: this.end2,
        strokeDashArray: 3,
        borderColor: '#32557c',
        fillColor: '#32557c',
        opacity: 1,
        stroke: {
          width: [4],
        },
        label: {
          borderColor: '#32557c',
          offsetX: 6,
          offsetY: 6,
          position: 'left',
          textAnchor: 'start',
          style: {
            color: '#fff',
            background: '#32557c',
          },
          // @ts-ignore
          text:
            this.getShortName(this.goalResult2?.goal?.name) +
            ' ' +
            this.end2!.toLocaleString('de-DE'),
        },
      });
    }

    if (this.goalResult1?.goal?.agencyValue) {
      annotations.push({
        y: this.goalResult1?.goal?.agencyValue,
        strokeDashArray: 0,
        borderColor: '#000',
        fillColor: '#000',
        opacity: 1,
        stroke: {
          width: [4],
        },
        label: {
          borderColor: '#000',
          offsetX: 6,
          offsetY: 6,
          position: 'left',
          textAnchor: 'start',
          style: {
            color: '#fff',
            background: '#000',
          },
          // @ts-ignore
          text: 'Agenturziel: ' + this.goalResult1?.goal?.agencyValue.toLocaleString('de-DE'),
        },
      });
    }

    this.chartOptions = {
      ...this.chartOptions,
      yaxis: [
        {
          show: false,
          // @ts-ignore
          max: this.max * 1.1,
        },
      ],
      annotations: {
        yaxis: annotations,
      },
    };
  }

  async mounted() {
    await this.loadResult();
  }

  chartOptions: any = {
    chart: {
      type: 'bar',
      stacked: true,

      toolbar: {
        show: false,
      },
    },
    xaxis: {
      categories: ['', 'VJ', 'Erg. + Anb.', ''],
      axisTicks: {
        show: true,
      },
      labels: {
        rotate: 0,
        rotateAlways: false,
      },
    },
    yaxis: [
      {
        show: false,
      },
    ],
    colors: [],
    grid: {
      show: true,
      borderColor: '#eeeeee',
      // padding: {
      //   top: -12,
      //   bottom: -12,
      // },
      padding: {
        top: 0,
        left: 0,
        right: 0,
      },
    },
    dataLabels: {
      enabled: false,
      style: {
        colors: ['#fff'],
        fontSize: '10px',
      },
      background: {
        enabled: false,
      },
      formatter: (val: number) => {
        return val.toLocaleString('de-DE');
      },
      offsetX: 0,
      offsetY: 0,
      textAnchor: 'middle',
    },
    plotOptions: {
      bar: {
        horizontal: false,
        dataLabels: {
          position: 'bottom',
        },
        borderRadius: 2,
        // columnWidth: '82%',
      },
    },
    tooltip: {
      fixed: {
        enabled: true,
        position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
        offsetY: 30,
        offsetX: 60,
      },
      y: {
        formatter: (value: number) => value.toLocaleString('de-DE'),
        title: {
          formatter: (seriesName: string) => seriesName.replace(/[0-9.]/g, ''),
        },
      },
    },
    legend: {
      show: false,
      offsetX: -15,

      offsetY: 5,
      // position: this.legendPosition,
      horizontalAlign: 'left',
    },
  };
  editGoal() {
    this.contextMenuVisible = false;
    (this.$refs['edit-fiv-goal-modal'] as any).$refs['edit-fiv-goal'].show();
  }

  get relativeResult() {
    return (this.result! / this.end1!) * 100;
  }

  get relativeLeads() {
    return (this.leads! / this.end1!) * 100;
  }
  get relativeForecast() {
    return (this.forecast! / this.end1!) * 100;
  }

  get forecast() {
    return this.result! + this.leads!;
  }

  get colors() {
    return {
      lastYear: '#a2acbd',
      result: '#245a99',
      submitted: '#79b2f5',
      open: '#3A7BC7',
      time: '#013781',
    };
  }

  getShortName(name = '') {
    return (
      name.replace('Gesamtbewertung', '').replace('Sach BZUWB', '').replace('n.Korr.', '').trim() ||
      ''
    );
  }
  getReadableName(name = '') {
    if (name.includes('Gesamtbewertung')) {
      return 'Gesamtbewertung';
    } else if (name.includes('Sach BZUWB')) {
      return 'Sach BZUWB n.Korr.';
    }
    return '';
  }
}
